/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import DownloadDocPresenter from './DownloadDocPresenter';
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  attachmentUrl: any;
}

const DownloadDocController = ({
  isModalOpen,
  closeModal,
  attachmentUrl,
}: ModalInterface) => {
  return (
    <DownloadDocPresenter
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      attachmentUrl={attachmentUrl}
    />
  );
};
export default DownloadDocController;
